module.exports = __webpack_public_path__ + "img/manajemen_kurir.f986455b.svg";